import { Menu } from '@headlessui/react'
import { useCreatePaymentMethodLocationConnection } from 'hooks/usePaymentMethodApi'
import { mapFavritAppToName } from 'utils/favritAppUtils'
import { FavritApp, PaymentMethodLocationConnectionDto } from '../../generated-api'
import Chip from './Chip'

type AddFavritAppToLocationMenuProps = {
    locationConnection: PaymentMethodLocationConnectionDto
    buttonElement: React.ReactNode
}

const AddFavritAppToLocationMenu = (props: AddFavritAppToLocationMenuProps) => {
    const { locationConnection, buttonElement } = props

    const { mutate: runCreateLocationConnection } = useCreatePaymentMethodLocationConnection(
        locationConnection.paymentProvider,
        locationConnection.paymentMethod,
        locationConnection.locationId
    )

    const handleAddApp = (favritApp: FavritApp) => {
        const updatedApps = new Set(locationConnection.enabledInApps)
        updatedApps.add(favritApp)

        runCreateLocationConnection({
            locationId: locationConnection.locationId,
            enabledInApps: updatedApps,
            overridableConfiguration: locationConnection.overridableConfiguration,
        })
    }

    const availableApps = locationConnection.enabledInApps
        ? Object.values(FavritApp).filter((x) => !locationConnection.enabledInApps!.has(x))
        : []

    return (
        <>
            <Menu as="div" className="relative inline-block text-left">
                <Menu.Button>{buttonElement}</Menu.Button>
                <Menu.Items className="absolute left-0 z-10 mt-2 w-[200px] bg-brand-white border border-[#e2e8f0] divide-y divide-[#e2e8f0] cursor-pointer">
                    {availableApps.map((availableApp) => (
                        <Menu.Item key={`add-app-menu-${availableApp}`}>
                            {({ active }) => (
                                <div
                                    onClick={() => handleAddApp(availableApp)}
                                    className={`flex text-brand-primary px-3 py-4 ${
                                        active ? 'bg-purple-lightest' : ''
                                    }`}
                                >
                                    <Chip size="medium" text={mapFavritAppToName(availableApp)} />
                                </div>
                            )}
                        </Menu.Item>
                    ))}
                </Menu.Items>
            </Menu>
        </>
    )
}

export default AddFavritAppToLocationMenu
